import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import {
  TourOperators,
  TourOperatorsTypes,
} from 'entities/tour/ui/tour-detail/model.ts'

import { Tour } from 'shared/api/tours/search'
import { getCleanHTML } from 'shared/lib/getCleanHTML.ts'
import { priceShow } from 'shared/lib/priceShow.ts'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types.ts'
import { Button } from 'shared/ui/button'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

interface Props {
  room?: Tour
  isViewMode?: boolean
  onRoomClick?: () => void
}

export const RoomItem = ({ room, isViewMode, onRoomClick }: Props) => {
  const { t } = useTranslation()

  return (
    <div className={s.container}>
      <div className={s.header}>
        <div className={s.prices}>
          <p className={clsx('extra-bold-16', s.som)}>
            {`${t('price_start', { price: priceShow(String(room?.price || 0)) })}`}
          </p>

          {room?.price_usd && (
            <p className={clsx('semi-bold-12', s.usd)}>
              ~&#36;{' '}
              {priceShow(String(Math.ceil(Number(room?.price_usd || 0))))}
            </p>
          )}
        </div>

        <ImageLazy
          alt="logo"
          src={
            room?.operator_icon_url ||
            TourOperators[room?.operator_icon as TourOperatorsTypes]?.icon
          }
          className={s.logo}
        />
      </div>

      <div className={s.box}>
        <p className={clsx('semi-bold-14', s.title)}>{room?.room}</p>

        <div className={s.services}>
          {room?.room_info?.descr && (
            <div className={s.service}>
              <AppIcon
                id={AllIcons.BED}
                className={s.icon}
                height={16}
                width={16}
              />
              <p
                className={clsx('medium-12', s.item)}
                dangerouslySetInnerHTML={{
                  __html: getCleanHTML(room?.room_info?.descr || ''),
                }}
              />
            </div>
          )}
          <div className={s.service}>
            <AppIcon
              id={AllIcons.FOOD}
              className={s.icon}
              height={16}
              width={16}
            />
            <p className={clsx('medium-12', s.item)}>{room?.meal_human}</p>
          </div>
        </div>
      </div>

      {!isViewMode && (
        <Button
          borderRadius="md"
          className={clsx('semi-bold-15', s.btn)}
          onClick={onRoomClick}
        >
          {t('select_without_date')}
        </Button>
      )}
    </div>
  )
}
